module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("content_report", [["a",{"class":"content-report-link"},[["i",{"class":"icon-au_report"}],["textNode",{"text":" "}],["span",{"class":"action-link-text"},[["textNode",{"text":"REPORT"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/contentreport.tpl
// module id = 61
// module chunks = 4